import { CapaPurchaseOrderStatus } from '@generated/graphql';
import { ProcessStateEnum } from './types';

const ClientColorCommentMap = {
  '계좌이체대기': '입금 대기중입니다.',
  '제조준비완료': '결제 완료되었습니다.',
  '제조시작': '파트너가 제조를 시작했습니다.',
  '배송시작': '배송이 시작되었습니다.',
  '구매확정일연기': '구매확정 기간을 연장했습니다.',
  '거래완료': '거래가 완료되었습니다.',
  '발주서거부': '파트너가 발주서를 거부했습니다.',
  '결제취소대기': '결제취소 요청 후 대기중입니다.',
  '결제취소완료': '결제취소가 완료되었습니다.',
  '환불대기': '환불 요청 후 대기중입니다.',
  '환불완료': '환불이 완료되었습니다.',
  '미입금취소': '입금 기간이 만료되었습니다.'
};

const ClientProcessStateToDescriptionMap = {
  '계좌이체대기':
    '고객님이 요청한 제조서비스를 파트너가 시작할 수 있도록 캐파 가상계좌로 결제 대금을 입금해주세요.',
  '제조준비완료': '이제 파트너가 제조를 시작할 수 있습니다.',
  '제조시작': '제조가 완료되면 파트너가 배송을 시작합니다.',
  '배송시작':
    '검품 후 이상이 없다면 구매확정해주세요. 구매확정 후 최소 3영업일, 최대 5영업일 내 파트너에게 대금이 지급됩니다. 고객님께서 직접 구매확정하지 않으면 배송정보 입력 일 기준으로 최대 20영업일 후에 대금이 지급됩니다. 결과물에 이상이 있을 경우 자동 구매확정 기간을 연장해주세요.',
  '구매확정일연기':
    '검품 후 이상이 없다면 구매확정해주세요. 구매확정 후 최소 3영업일, 최대 5영업일 내 파트너에게 대금이 지급됩니다.',
  '거래완료':
    '파트너와의 거래는 어떠셨나요? 고객님의 소중한 후기를 작성해주세요.',
  '발주서거부':
    '프로젝트가 결제/발주 단계에서 중단됩니다. 해당 발주서의 결제 대금은 고객님께 자동 환불됩니다.',
  '결제취소대기':
    '파트너가 결제취소 요청 승인 시 결제 대금은 자동 환불됩니다. 구체적인 결제취소 내용은 채팅을 통해 파트너와 상담하세요.',
  '결제취소완료':
    '프로젝트가 결제/발주 단계에서 중단됩니다. 해당 발주서의 결제 대금은 자동 환불됩니다.',
  '환불대기':
    '파트너가 환불요청 승인 시 결제 대금은 자동 환불됩니다. 환불 관련 상담은 파트너와 채팅을 통해 진행해주세요.',
  '환불완료':
    '프로젝트가 제조 단계에서 중단됩니다. 해당 발주서의 결제 대금은 고객님께 자동 환불됩니다.',
  '미입금취소':
    '프로젝트가 결제/발주 단계에서 중단됩니다. 거래를 계속 진행하고 싶다면 파트너에게 발주서를 재발행하세요.'
};

const PartnerProcessStateToDescriptionMap = {
  '계좌이체대기':
    '고객님이 발주서를 전달했습니다. 고객님이 캐파 가상계좌에 입금 후 최소 2영업일, 최대 7영업일 후에 고객님과 제조시작을 할 수있습니다.',
  '제조준비완료':
    '발주서 및 결제내역을 확인하고 제조시작 버튼을 눌러주세요. 제조시작 전에는 발주서를 거절할 수 있고, 거절하면 결제 대금이 고객에게 환불됩니다. 마찬가지로 파트너님이 제조중으로 상태 변경 전까지는 결제 취소 할 수 있습니다.',
  '제조시작':
    '배송이 완료되면 고객이 검품 후 구매확정을 할 수 있습니다. 만약 고객이 구매확정을 하지 않으면 배송방식 입력일을 기준으로 21일(영업일 기준) 뒤에 자동 구매확정 처리되니 꼭 배송정보를 입력해주세요.',
  '배송시작':
    '고객님이 검품 후 바로 구매확정 또는 구매확정연장을 요청할 수 있습니다. 고객이 구매확정 한 이후 최소 2영업일 최대 7영업일 내에 등록하신 정산계좌로 정산 예정 금액이 지급됩니다. 만약 고객이 구매확정을 하지 않으면 배송정보 입력일을 기준으로 21일(영업일 기준) 뒤에 자동 구매확정 처리됩니다.',
  '거래완료': '고객님과의 거래는 어떠셨나요?',
  '발주서거부':
    '프로젝트가 제조 단계에서 중단됩니다. 해당 발주서의 결제 대금은 고객님께 자동 환불됩니다.',
  '결제취소대기':
    '파트너가 결제취소 요청 승인 시 결제 대금은 자동 환불됩니다. 구체적인 결제취소 내용은 채팅을 통해 파트너와 상담하세요.',
  '결제취소완료':
    '프로젝트가 제조 단계에서 중단됩니다. 해당 발주서의 결제 대금은 고객님께 자동 환불됩니다.',
  '환불대기':
    '환불 요청 승인시 결제금이 고객님께 환불됩니다. 채팅을 통해 파트너와 상담을 먼저 진행해 주세요. 이후에 채널톡으로 문의해주세요',
  '환불완료':
    '프로젝트가 제조 단계에서 중단됩니다. 해당 발주서의 결제 대금은 고객님께 자동 환불됩니다.'
};

const ProcessStateToTitleMap = {
  '계좌이체대기': '결제/발주중',
  '제조준비완료': '결제/발주중',
  '제조시작': '제조중',
  '배송시작': '배송중',
  '거래완료': '거래완료',
  '발주서거부': '결제/발주중단',
  '결제취소대기': '결제/발주중단',
  '결제취소완료': '결제/발주중단',
  '미입금취소': '결제/발주중단',
  '환불대기': '제조중단',
  '환불완료': '제조중단',
  '구매확정일연기': '배송중'
};

const ProgressStoppedStatus = [
  CapaPurchaseOrderStatus.RejectOrderByPartner,
  CapaPurchaseOrderStatus.CancelRequested,
  CapaPurchaseOrderStatus.CancelConfirmed,
  CapaPurchaseOrderStatus.RefundRequested,
  CapaPurchaseOrderStatus.RefundConfirmed,
  CapaPurchaseOrderStatus.CancelledByAdmin,
  CapaPurchaseOrderStatus.NotPaidCanceled
];

export const purchaseOrderStatusToKorean: Partial<Record<
  CapaPurchaseOrderStatus,
  ProcessStateEnum
>> = {
  PROCESS_PAYMENT: ProcessStateEnum.계좌이체대기,
  PAID: ProcessStateEnum.제조준비완료,
  PROCESSING: ProcessStateEnum.제조시작,
  SHIPPING: ProcessStateEnum.배송시작,
  PURCHASE_CONFIRMED: ProcessStateEnum.거래완료,
  REJECT_ORDER_BY_PARTNER: ProcessStateEnum.발주서거부,
  CANCEL_REQUESTED: ProcessStateEnum.결제취소대기,
  CANCEL_CONFIRMED: ProcessStateEnum.결제취소완료,
  REFUND_REQUESTED: ProcessStateEnum.환불대기,
  REFUND_CONFIRMED: ProcessStateEnum.환불완료,
  NOT_PAID_CANCELED: ProcessStateEnum.미입금취소,
  CANCELLED_BY_ADMIN: ProcessStateEnum.결제취소완료
};

export {
  ClientColorCommentMap,
  ClientProcessStateToDescriptionMap,
  ProcessStateToTitleMap,
  PartnerProcessStateToDescriptionMap,
  ProgressStoppedStatus
};
